// extracted by mini-css-extract-plugin
export default {"footerNavLink":"Footer_footerNavLink__gkF1L","footerLink":"Footer_footerLink__HTzFq"};